import { Box, Container, Typography } from '@mui/material';

const DataPrivacy = () => {
  return (
    <>
      {/* DISCLAIMER */}
      <Box py={5} bgcolor="#ffffff">
        <Container maxWidth="md">
          <Typography variant="h5" fontWeight={700} textAlign="center" mb={2}>
            Data Protection & Privacy
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            textAlign="center"
            sx={{ lineHeight: 1.7 }}
          >
            We do not store any personal data beyond what is required to
            activate your account. You may delete your data at any time. While
            we use strong security measures, we cannot guarantee absolute
            protection and are not responsible for external breaches. You may
            use an anonymous identity or nickname if you prefer.
          </Typography>
        </Container>
      </Box>
    </>
  );
}

export default DataPrivacy;